import React, { useState } from 'react';

const XiamenTripPlanner = () => {
  const [activeTab, setActiveTab] = useState('mainRoute');
  const [activePeriod, setActivePeriod] = useState('morning');
  const [showFoodDetails, setShowFoodDetails] = useState(false);
  const [showTipDetails, setShowTipDetails] = useState(false);
  const [selectedFood, setSelectedFood] = useState(null);
  
  const foods = [
    {
      name: '沙茶面',
      description: '厦门最具代表性的面食，以独特的沙茶酱为汤底，加入豆干、肉片等食材。',
      price: '20-30元/碗',
      shops: ['四里沙茶面', '月华沙茶面', '乌堂沙茶面'],
      image: '/api/placeholder/300/200'
    },
    {
      name: '海蛎煎',
      description: '厦门特色小吃，外酥内嫩，香气四溢。',
      price: '15-20元/份',
      shops: ['曾厝垵小吃街', '中山路小吃摊', '八市海蛎煎'],
      image: '/api/placeholder/300/200'
    },
    {
      name: '土笋冻',
      description: '一种特殊的海鲜凉菜，口感独特，可搭配芥末或酱油食用。',
      price: '15-20元/份',
      shops: ['曾厝垵小吃街', '中山路海鲜店'],
      image: '/api/placeholder/300/200'
    },
    {
      name: '姜母鸭',
      description: '以鸭肉和大量姜片烹制，味道鲜美，是秋冬进补佳品。',
      price: '80-100元/只',
      shops: ['老祖宗姜母鸭', '朱记姜母鸭'],
      image: '/api/placeholder/300/200'
    },
    {
      name: '烧肉粽',
      description: '与北方粽子不同，厦门烧肉粽配料丰富，通常搭配辣酱食用。',
      price: '10-15元/个',
      shops: ['1980烧肉粽', '好味道肉粽'],
      image: '/api/placeholder/300/200'
    }
  ];
  
  const attractions = {
    '曾厝垵': {
      description: '被誉为"最文艺的渔村"，汇集了众多文创小店和美食，是体验厦门慢生活的绝佳去处。',
      image: '/api/placeholder/400/300'
    },
    '厦门大学': {
      description: '有"中国最美大学"之称，校园环境优美，历史建筑与自然风光相结合，文化氛围浓厚。',
      image: '/api/placeholder/400/300'
    },
    '南普陀寺': {
      description: '历史悠久的佛教寺院，建筑风格独特，香火旺盛，可以感受闽南传统文化和宗教氛围。',
      image: '/api/placeholder/400/300'
    },
    '环岛路': {
      description: '全长近30公里的滨海道路，沿途风景优美，可欣赏到海滨风光和城市景观。',
      image: '/api/placeholder/400/300'
    },
    '中山路步行街': {
      description: '厦门传统商业街，有众多美食和纪念品店铺，是购物和品尝当地特色美食的好去处。',
      image: '/api/placeholder/400/300'
    },
    '鼓浪屿': {
      description: '厦门著名的海岛景点，有"钢琴之岛"、"万国建筑博览会"之称，有日光岩、菽庄花园等景点。',
      image: '/api/placeholder/400/300'
    }
  };
  
  const tips = [
    '提前预约厦门大学参观，至少提前1天，通过"厦门大学访客预约系统"微信公众号',
    '注意北站快线的发车时间，高峰期约15分钟一班',
    '夏季带好防晒用品，冬季注意保暖',
    '携带充足饮用水，厦门夏季气温较高',
    '保管好随身物品，特别是在人流密集的景点',
    '提前查看天气预报，雨天建议调整行程，重点游览室内景点'
  ];
  
  const routes = {
    mainRoute: {
      title: '经典行程：厦大+南普陀+环岛路',
      morning: [
        {time: '9:10-9:30', activity: '抵达厦门北站，办理乘车手续', place: '厦门北站'},
        {time: '9:30-9:45', activity: '乘坐"北站快线"前往岛内', place: '北站快线'},
        {time: '9:45-11:45', activity: '游览曾厝垵', place: '曾厝垵'},
        {time: '11:45-12:30', activity: '午餐时间', place: '曾厝垵'}
      ],
      afternoon: [
        {time: '12:30-13:00', activity: '前往厦门大学', place: '厦门大学'},
        {time: '13:00-15:00', activity: '游览厦门大学', place: '厦门大学'},
        {time: '15:00-15:30', activity: '前往南普陀寺', place: '南普陀寺'},
        {time: '15:30-16:30', activity: '游览南普陀寺', place: '南普陀寺'},
        {time: '16:30-17:30', activity: '前往鼓浪屿码头', place: '鼓浪屿码头'},
        {time: '17:30-18:30', activity: '漫步环岛路或中山路', place: '环岛路'}
      ],
      evening: [
        {time: '18:30-19:30', activity: '晚餐时间', place: '中山路'},
        {time: '19:30-20:00', activity: '回到厦门北站', place: '厦门北站'}
      ]
    },
    alternativeRoute1: {
      title: '鼓浪屿一日游',
      morning: [
        {time: '9:10-10:00', activity: '从厦门北站到厦鼓码头', place: '厦门北站'},
        {time: '10:00-10:20', activity: '乘船前往鼓浪屿（船票35元/人，含往返）', place: '厦鼓码头'},
        {time: '10:20-12:00', activity: '游览鼓浪屿（日光岩、菽庄花园等）', place: '鼓浪屿'}
      ],
      afternoon: [
        {time: '12:00-13:00', activity: '在鼓浪屿享用午餐', place: '鼓浪屿'},
        {time: '13:00-16:00', activity: '继续游览鼓浪屿', place: '鼓浪屿'},
        {time: '16:00-16:30', activity: '返回厦门本岛', place: '厦鼓码头'}
      ],
      evening: [
        {time: '16:30-19:30', activity: '游览中山路和环岛路', place: '中山路'},
        {time: '19:30-20:00', activity: '返回厦门北站', place: '厦门北站'}
      ]
    },
    alternativeRoute2: {
      title: '悠闲环岛路',
      morning: [
        {time: '9:10-10:00', activity: '从厦门北站到白城海滩', place: '厦门北站'},
        {time: '10:00-12:00', activity: '在白城海滩租自行车沿环岛路骑行', place: '环岛路'}
      ],
      afternoon: [
        {time: '12:00-13:30', activity: '在附近海鲜餐厅用午餐', place: '环岛路'},
        {time: '13:30-15:30', activity: '游览厦门大学', place: '厦门大学'},
        {time: '15:30-16:30', activity: '游览南普陀寺', place: '南普陀寺'}
      ],
      evening: [
        {time: '16:30-19:30', activity: '游览中山路步行街，品尝当地美食', place: '中山路'},
        {time: '19:30-20:00', activity: '返回厦门北站', place: '厦门北站'}
      ]
    }
  };
  
  const transportations = [
    {
      name: '北站快线',
      description: '厦门北站南站房的旅游综合服务中心乘坐，15分钟可直达岛内',
      price: '10元/人',
      frequency: '约15分钟一班',
      lastBus: '23:30'
    },
    {
      name: '地铁1号线',
      description: '可从厦门北站乘坐到镇海路站',
      price: '3-5元/人',
      duration: '约30分钟'
    },
    {
      name: 'BRT快线',
      description: '快1路（到第一码头）、快6路（到前埔枢纽站）、快7路（到同安枢纽站）',
      price: '2-3元/人',
      frequency: '约10分钟一班'
    }
  ];
  
  const showFoodDetail = (food) => {
    setSelectedFood(food);
    setShowFoodDetails(true);
  };
  
  const formatCostBreakdown = () => {
    return (
      <div className="bg-blue-50 p-4 rounded-lg shadow-sm">
        <h3 className="text-lg font-bold mb-2">费用预估</h3>
        <div className="grid grid-cols-2 gap-2">
          <div>交通费</div>
          <div>约50元</div>
          <div>餐饮费</div>
          <div>约200元</div>
          <div>门票费</div>
          <div>免费(厦大、南普陀寺均免费)</div>
          <div>其他费用</div>
          <div>约50元</div>
          <div className="font-bold">总计</div>
          <div className="font-bold">约300元/人</div>
        </div>
        <p className="text-sm mt-2">注：如选择鼓浪屿一日游，需增加约150元/人</p>
      </div>
    );
  };
  
  const activeRoute = routes[activeTab];
  const activePeriodSchedule = activeRoute[activePeriod];
  
  return (
    <div className="max-w-4xl mx-auto bg-white p-4 rounded-lg shadow">
      <div className="text-center mb-6">
        <h1 className="text-2xl font-bold text-blue-600">厦门一日游行程规划</h1>
        <p className="text-gray-600">从厦门北站9:10到达到晚上20:00返回</p>
      </div>
      
      {/* 交通信息 */}
      <div className="mb-6">
        <h2 className="text-xl font-bold mb-2 text-blue-800 border-b border-blue-200 pb-1">交通概况</h2>
        <div className="grid md:grid-cols-3 gap-4">
          {transportations.map((transport, idx) => (
            <div key={idx} className="bg-blue-50 p-3 rounded shadow-sm hover:shadow-md transition-shadow">
              <h3 className="font-bold text-blue-700">{transport.name}</h3>
              <p className="text-sm text-gray-700">{transport.description}</p>
              <p className="text-sm mt-1">
                <span className="font-medium">票价:</span> {transport.price}
                {transport.duration && <span> | <span className="font-medium">用时:</span> {transport.duration}</span>}
                {transport.frequency && <span> | <span className="font-medium">频次:</span> {transport.frequency}</span>}
                {transport.lastBus && <span> | <span className="font-medium">末班:</span> {transport.lastBus}</span>}
              </p>
            </div>
          ))}
        </div>
      </div>
      
      {/* 行程选择 */}
      <div className="mb-6">
        <h2 className="text-xl font-bold mb-2 text-blue-800 border-b border-blue-200 pb-1">行程选择</h2>
        <div className="flex mb-4 overflow-x-auto">
          <button 
            className={`px-4 py-2 mr-2 whitespace-nowrap rounded-t-lg ${activeTab === 'mainRoute' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
            onClick={() => setActiveTab('mainRoute')}
          >
            经典行程
          </button>
          <button 
            className={`px-4 py-2 mr-2 whitespace-nowrap rounded-t-lg ${activeTab === 'alternativeRoute1' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
            onClick={() => setActiveTab('alternativeRoute1')}
          >
            鼓浪屿一日游
          </button>
          <button 
            className={`px-4 py-2 whitespace-nowrap rounded-t-lg ${activeTab === 'alternativeRoute2' ? 'bg-blue-600 text-white' : 'bg-gray-200'}`}
            onClick={() => setActiveTab('alternativeRoute2')}
          >
            悠闲环岛路
          </button>
        </div>
        
        <h3 className="text-lg font-bold mb-2 text-blue-700">{activeRoute.title}</h3>
        
        {/* 时间段选择 */}
        <div className="flex mb-4">
          <button 
            className={`px-4 py-1 mr-2 rounded ${activePeriod === 'morning' ? 'bg-yellow-500 text-white' : 'bg-yellow-100'}`}
            onClick={() => setActivePeriod('morning')}
          >
            上午
          </button>
          <button 
            className={`px-4 py-1 mr-2 rounded ${activePeriod === 'afternoon' ? 'bg-blue-500 text-white' : 'bg-blue-100'}`}
            onClick={() => setActivePeriod('afternoon')}
          >
            下午
          </button>
          <button 
            className={`px-4 py-1 rounded ${activePeriod === 'evening' ? 'bg-purple-500 text-white' : 'bg-purple-100'}`}
            onClick={() => setActivePeriod('evening')}
          >
            晚上
          </button>
        </div>
        
        {/* 行程详情 */}
        <div className="bg-gray-50 p-4 rounded shadow-sm">
          {activePeriodSchedule.map((item, idx) => {
            const attraction = attractions[item.place];
            return (
              <div key={idx} className="mb-4 bg-white p-3 rounded shadow-sm hover:shadow-md transition-shadow">
                <div className="flex flex-col md:flex-row justify-between">
                  <div className="mb-2 md:mb-0">
                    <div className="font-bold text-gray-700">{item.time}</div>
                    <div className="text-blue-600 font-medium">{item.activity}</div>
                    <div className="text-sm text-gray-600">{item.place}</div>
                  </div>
                  {attraction && (
                    <div className="md:ml-4 flex flex-col items-center md:items-end">
                      <img src={attraction.image} alt={item.place} className="w-full md:w-32 h-24 object-cover rounded mb-2" />
                      <div className="text-xs text-gray-500 text-center md:text-right">{attraction.description.substring(0, 50)}...</div>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      
      {/* 美食推荐 */}
      <div className="mb-6">
        <h2 className="text-xl font-bold mb-2 text-blue-800 border-b border-blue-200 pb-1">
          美食推荐
          <button 
            className="ml-2 text-sm bg-orange-500 text-white px-3 py-1 rounded"
            onClick={() => setShowFoodDetails(!showFoodDetails)}
          >
            {showFoodDetails ? '收起' : '查看详情'}
          </button>
        </h2>
        
        {showFoodDetails && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
            {foods.map((food, idx) => (
              <div key={idx} className="bg-orange-50 p-3 rounded shadow-sm hover:shadow-md transition-shadow" onClick={() => showFoodDetail(food)}>
                <div className="flex">
                  <img src={food.image} alt={food.name} className="w-24 h-24 object-cover rounded mr-3" />
                  <div>
                    <h3 className="font-bold text-orange-700">{food.name}</h3>
                    <p className="text-xs text-gray-600 mt-1">{food.description}</p>
                    <p className="text-sm mt-1"><span className="font-medium">推荐价格:</span> {food.price}</p>
                    <p className="text-sm"><span className="font-medium">推荐店铺:</span> {food.shops.join(', ')}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        
        {!showFoodDetails && (
          <div className="flex overflow-x-auto space-x-2 pb-2">
            {foods.map((food, idx) => (
              <div key={idx} className="flex-shrink-0 text-center">
                <img src={food.image} alt={food.name} className="w-16 h-16 object-cover rounded-full border-2 border-orange-300" />
                <div className="text-xs mt-1">{food.name}</div>
              </div>
            ))}
          </div>
        )}
      </div>
      
      {/* 费用预估 */}
      <div className="mb-6">
        {formatCostBreakdown()}
      </div>
      
      {/* 温馨提示 */}
      <div className="mb-6">
        <h2 className="text-xl font-bold mb-2 text-blue-800 border-b border-blue-200 pb-1">
          温馨提示
          <button 
            className="ml-2 text-sm bg-green-500 text-white px-3 py-1 rounded"
            onClick={() => setShowTipDetails(!showTipDetails)}
          >
            {showTipDetails ? '收起' : '查看详情'}
          </button>
        </h2>
        
        {showTipDetails ? (
          <ul className="list-disc pl-5 space-y-2">
            {tips.map((tip, idx) => (
              <li key={idx} className="text-gray-700">{tip}</li>
            ))}
          </ul>
        ) : (
          <p className="text-gray-600">点击"查看详情"按钮查看6条重要提示信息</p>
        )}
      </div>
      
      {/* 互动功能 */}
      <div className="bg-blue-600 text-white p-4 rounded-lg text-center">
        <p className="font-bold mb-2">拖放行程并自定义您的厦门之旅！</p>
        <p className="text-sm">点击上方的行程选项，发现更多厦门旅游可能</p>
      </div>
    </div>
  );
};

export default XiamenTripPlanner;